import React, { memo } from 'react';
import useI18n from '../hooks/useI18n';

function I18n({ value, defaultValue, variables, children }) {
  const getValue = useI18n();
  if (!value && typeof children === 'function') {
    return <>{children(getValue())}</>;
  }
  const i18nVal = getValue(value, defaultValue, variables);
  if (typeof children === 'function') {
    return <>{children(i18nVal)}</>;
  }

  if (typeof i18nVal !== 'string') {
    return <>{defaultValue || value}</>;
  }

  return <>{i18nVal}</>;
}

export default memo(I18n);
